export default "__VITE_ASSET__b4c5f417__"